import React from "react";
import ReactDOM from 'react-dom';

export default class CheckedCompoment extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            ventes:JSON.parse(this.props.value),
            values:[],
            psvs:JSON.parse(this.props.psvs),
            tab:[],
        }
        this.handleSelect = this.handleSelect.bind(this);
    }

    componentDidMount() {
        const {psvs,tab,values} = this.state;
        psvs.map(value => {
            tab.push(value.service_vente_id);
            values.push(""+value.service_vente_id+"")
            let vente = document.querySelector('#vente');
                vente.value = JSON.stringify(values);
        })
        this.setState({tab})
    }

    handleSelect(value){
        let {values,tab} = this.state;
        if(values.indexOf(value) === -1) {
            values.push(value);
            tab.push(parseInt(value));
            this.setState({values,tab}, () => {
                let vente = document.querySelector('#vente');
                vente.value = JSON.stringify(values);
            });
        }else{
            const i = values.indexOf(value);
            values.splice(i, 1);
            tab.splice(i, 1)
            this.setState({values,tab});
            let vente = document.querySelector('#vente');
                vente.value = JSON.stringify(values);
        }
    }
    render(){
        return (
            <div>
                {
                    this.state.ventes.map((value,index) => (
                        <div className="checkVente" key={index}>
                            <input  type="checkbox" checked={this.state.tab.indexOf(value.id) !== -1 ? "checked" : ""} value={value.id} onChange={(e) => this.handleSelect(e.target.value)} /><label>{value.name}</label>
                        </div>
                    ))
                }
            </div>
        )
    }
}
if (document.getElementById('checkedVente')) {
    const element = document.getElementById('checkedVente');
    let props = Object.assign({}, element.dataset);
    ReactDOM.render(<CheckedCompoment {...props}/>, document.getElementById('checkedVente'));
}
